import React from 'react';
import { SvgProps } from 'apps/sigma2-ui/src/components/svg/types';
import { toSvgColor } from 'apps/sigma2-ui/src/components/svg/types';

export const IconStackedBarChartGroup: React.FC<SvgProps> = (props) => {
  const fillColor = toSvgColor('currentColor', props);

  return (
    <g>
      <path
        stroke={fillColor}
        strokeLinecap="round"
        strokeLinejoin="round"
        d="m2.1785714285714284 10.892857142857142 0 -6.535714285714285c0 -1.2031814285714284 0.97539 -2.1785714285714284 2.1785714285714284 -2.1785714285714284l21.785714285714285 0c1.203225 0 2.1785714285714284 0.97539 2.1785714285714284 2.1785714285714284l0 6.535714285714285c0 1.203203214285714 -0.9753464285714285 2.1785714285714284 -2.1785714285714284 2.1785714285714284L4.357142857142857 13.07142857142857c-1.2031814285714284 0 -2.1785714285714284 -0.97539 -2.1785714285714284 -2.1785714285714284Z"
        strokeWidth="1.5"
      ></path>
      <path
        stroke={fillColor}
        strokeLinecap="round"
        strokeLinejoin="round"
        d="m2.1785714285714284 26.14285714285714 0 -6.535714285714285c0 -1.2031814285714284 0.97539 -2.1785714285714284 2.1785714285714284 -2.1785714285714284l21.785714285714285 0c1.203225 0 2.1785714285714284 0.97539 2.1785714285714284 2.1785714285714284l0 6.535714285714285c0 1.203225 -0.9753464285714285 2.1785714285714284 -2.1785714285714284 2.1785714285714284L4.357142857142857 28.32142857142857c-1.2031814285714284 0 -2.1785714285714284 -0.9753464285714285 -2.1785714285714284 -2.1785714285714284Z"
        strokeWidth="1.5"
      ></path>
      <path
        stroke={fillColor}
        strokeLinecap="round"
        strokeLinejoin="round"
        d="m19.607142857142854 2.1785714285714284 0 10.892857142857142"
        strokeWidth="1.5"
      ></path>
      <path
        stroke={fillColor}
        strokeLinecap="round"
        strokeLinejoin="round"
        d="m10.892857142857142 2.1785714285714284 0 10.892857142857142"
        strokeWidth="1.5"
      ></path>
      <path
        stroke={fillColor}
        strokeLinecap="round"
        strokeLinejoin="round"
        d="m10.892857142857142 17.428571428571427 0 10.892857142857142"
        strokeWidth="1.5"
      ></path>
    </g>
  );
};

export const IconStackedBarChartSvg: React.FC<SvgProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="-0.75 -0.75 32 32"
      height="32"
      width="32"
      transform="scale(-1 -1)"
      fill="none"
      {...(props.svg ?? {})}
    >
      <IconStackedBarChartGroup {...props} />
    </svg>
  );
};
